export default __webpack_public_path__ + "static/media/Backvideo.ed25ee21.mp4";